import type { CanalResumen } from '../api';
import { etiquetaDeCanal } from '../canales';
import { Tabla } from './Tabla';

/**
 * El mismo proceso, canal por canal.
 *
 * Va arriba del embudo y no en una pestaña aparte porque es donde nace la
 * pregunta: al ver que un proceso se cae, lo primero que quiere saber negocio
 * es si se cae parejo o si hay un canal peor que el otro.
 */

function porcentaje(valor: number, total: number): number {
  return total > 0 ? Math.round((valor / total) * 1000) / 10 : 0;
}

export function ComparativaCanales({
  canales,
  seleccionado,
  onSeleccionar,
}: {
  canales: CanalResumen[];
  /** Canal filtrado actualmente, o '' para todos. */
  seleccionado: string;
  onSeleccionar: (canal: string) => void;
}) {
  // Con un solo canal no hay nada que comparar: la tabla sería ruido.
  if (canales.length < 2) return null;

  const peorAbandono = Math.max(
    ...canales.map((c) => porcentaje(Number(c.abandonados), Number(c.ejecuciones)))
  );

  return (
    <section className="comparativa">
      <h3>Por canal</h3>
      <Tabla>
        <thead>
          <tr>
            <th>Canal</th>
            <th className="num">Ejecuciones</th>
            <th className="num">Éxito</th>
            <th className="num">Abandono</th>
            <th className="num">Error</th>
            <th className="num">p95</th>
          </tr>
        </thead>
        <tbody>
          {canales.map((c) => {
            const total = Number(c.ejecuciones);
            const abandono = porcentaje(Number(c.abandonados), total);
            const activo = seleccionado === c.canal;

            return (
              <tr
                key={c.canal}
                className={`clicable ${activo ? 'seleccionada' : ''}`}
                onClick={() => onSeleccionar(activo ? '' : c.canal)}
                title={activo ? 'Quitar el filtro' : `Ver solo ${etiquetaDeCanal(c.canal)}`}
              >
                <td>
                  <span className={`canal ${c.canal}`}>{etiquetaDeCanal(c.canal)}</span>
                </td>
                <td className="num">{total}</td>
                <td className="num">{porcentaje(Number(c.ok), total)}%</td>
                <td className={`num ${abandono === peorAbandono && canales.length > 1 ? 'malo' : ''}`}>
                  {abandono}%
                </td>
                <td className="num">{porcentaje(Number(c.con_error), total)}%</td>
                <td className="num">{c.p95_ms} ms</td>
              </tr>
            );
          })}
        </tbody>
      </Tabla>
      <p className="tenue">Haz clic en un canal para filtrar el embudo y las ejecuciones.</p>
    </section>
  );
}
